import styled from 'styled-components';

import {
    TableView as TableView20,
    Root as Root20,
    CellContainer as CellContainer20,
    HeaderCell as HeaderCell20,
    Footer as Footer20,
} from 'components/ui-kit/Table2.0/Table/styled';
import {border, buttonReset, colors, font} from 'theme';

export const Root = styled(Root20)``;

export const TableView = styled(TableView20)`
    width: 100%;
    overflow-x: visible;
`;

export const CellContainer = styled(CellContainer20)``;

export const HeaderCell = styled(HeaderCell20)``;

export const Footer = styled(Footer20)``;

export const PaginationContainer = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const PageInfo = styled.span`
    font-size: 12px;
    color: ${colors.textMuted};
`;

export const PaginationControls = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const PaginationButton = styled.button`
    ${buttonReset};
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ddd;
    background-color: ${colors.transparent};
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    &:not(:disabled):hover {
        background-color: ${colors.background};
    }
`;

export const PageSizeSelect = styled.select`
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ddd;
    background-color: ${colors.white};
    cursor: pointer;
    margin-left: 10px;
`;
export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 8px;
`;
export const RowText = styled.div<{padding?: string}>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    color: ${colors.black};
    padding: ${(p) => p.padding ?? '0 16px'};
    border-radius: ${border.radius};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
`;

export const RowTextEllipsis = styled.div`
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 30ch;
`;

export const DefaultCell = styled.div<{
    noPadding: string;
    fullUneditableFields: string[];
    id: string;
    allowEditing: boolean;
}>`
    width: 100%;
    height: auto;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: ${(p) => p.noPadding};
    cursor: ${(p) =>
        p.fullUneditableFields.includes(p.id) || !p.allowEditing ? 'default' : 'pointer'};
`;

export const TextWrapperRow = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    gap: 8px;
    padding: 8px 0;
`;

export const TextWrapperItem = styled.div<{withSeparator?: boolean}>`
    display: inline-flex;
    align-items: center;
    justify-content: stretch;
    gap: 8px;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.darkGrey};
    ${(p) =>
        p.withSeparator &&
        `
            &:before {
                content: '';
                width: 1px;
                height: 18px;
                background: ${colors.textMuted};
            }
        `}
`;

export const GroupByGtinButtonRoot = styled.button`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    gap: 8px;
    padding: 0 16px;
    margin: 0;
    border: none;
    background: none;
    cursor: pointer;
`;
